import React from 'react';
export function HeroSection() {
  return <section className="px-5 py-8 bg-[#fffde7] text-center max-w-md mx-auto" data-id="element-72">
      {/* Label */}
      <div className="mb-4" data-id="element-73">
        <span className="inline-block px-3 py-1 bg-[#fff9c4] text-yellow-800 text-sm font-bold rounded-lg" data-id="element-74">
          EDUCANDO A NUESTROS PEQUES
        </span>
      </div>

      {/* Heading */}
      <h1 className="text-[1.8rem] font-black leading-[1.3] text-gray-900 mt-4" data-id="element-75">
        Tu bebé no necesita más juguetes.
        <br data-id="element-76" />
        <span className="bg-[#fff176] px-1 box-decoration-clone" data-id="element-77">
          Necesita momentos que programen su mente.
        </span>
      </h1>

      {/* Subheading */}
      <p className="text-base font-medium text-gray-800 mt-3" data-id="element-78">
        Esta guía es el regalo que activa su desarrollo desde el amor y el
        juego.
      </p>

      {/* Activity count */}
      <p className="text-[#f50057] text-sm font-bold mt-2" data-id="element-79">
        +260 ACTIVIDADES + 2 BONOS DE REGALO
      </p>

      {/* Emotional box */}
      <div className="bg-[#e3f2fd] text-[0.95rem] text-gray-700 px-4 py-4 rounded-xl mt-4 leading-relaxed" data-id="element-80">
        <p data-id="element-81">🌟 Este nuevo año es una puerta al crecimiento compartido ❤️</p>
        <p className="mt-1" data-id="element-82">
          Regálale a tu peque lo más valioso: tu tiempo, tu atención y momentos
          que encienden su mente.
        </p>
        <p className="mt-1" data-id="element-83">
          Porque cada juego con amor… se convierte en un recuerdo eterno 🌈
        </p>
      </div>

      {/* Main Image */}
      <img src="https://cdn.magicpatterns.com/uploads/54vcQqioARGPuH2L2oF4X9/ChatGPT-Image-29-abr-2025-22_27_41-1-1024x683.png" alt="Portada del libro y familia feliz" className="w-full h-auto mt-4 rounded-lg" data-id="element-84" />

      {/* Social Proof */}
      <p className="text-[0.85rem] text-gray-500 mt-3" data-id="element-85">
        Más de 5,600 familias, mamás y educadoras ya están viendo resultados
        reales.
      </p>

      <div className="mt-2" data-id="element-86">
        <img src="https://cdn.magicpatterns.com/uploads/pEk6eYbRuWAXzQz7zicke9/Evaluacion-general-de-Educando-Peques-¡Excelente-4.9-5-1.245-1.png" alt="Valoraciones 5 estrellas" className="mx-auto max-w-[260px]" data-id="element-87" />
      </div>

      {/* CTA Button */}
      <button className="w-full mt-6 text-white font-bold text-base py-4 px-5 rounded-xl text-center" style={{
      backgroundColor: '#ff6f61',
      boxShadow: '0 4px 14px rgba(255, 111, 97, 0.4)'
    }} onClick={() => {
      const section = document.getElementById('oferta-especial');
      if (section) {
        section.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }} data-id="element-88">
        Sí, quiero ayudar a mi bebé a desarrollarse mejor ⬇️
      </button>
    </section>;
}